<template>
  <div style="min-height: 600px;">
    <div class="row">
      <div class="col-xs-12">
        <div class="hpanel">
          <div class="">
            <p class="text-center m-b">
              <a :href="videoUrl" target="_blank" class="text-info font-bold"><i class="far fa-play-circle"></i> Watch
                the 2mn video</a>
            </p>

            <div class="row" style="margin-top: 15px">
              <div class="col-lg-6  hpanel hblue" id="lea-basic1">
                <div class="panel-body">
                  <table style="width: 100%;border-spacing: 2em;border-collapse: separate;">
                    <tbody>
                    <tr>
                      <td width="20%" class="text-right"><img :src="$apiUrl + '/se/graduation-cap.png'" alt="graduation-cap"></td>
                      <td width="80%" class="text-left" style="padding-left: 30px">
                        <h5>LEA allows you to look and connect with Edison Experts from Schneider Electric</h5>
                      </td>
                    </tr>
                    <tr style="margin-top: 15px">
                      <td width="20%" class="text-right"><img :src="$apiUrl + '/se/collaboration.png'" alt="handshake"></td>
                      <td width="80%" class="text-left" style="padding-left: 30px">
                        <h5>Connect with external experts & Search for Companies</h5>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <div style="margin-top: 15px">
                    <div class="col-xs-12 text-center">
                      <router-link type="button" :loading="false" :to="{name:'AboutEdison'}"
                                   class="btn btn-info btn-outline">More about Edison Program
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-lg-6 hpanel hblue" id="lea-basic2">
                <div class="panel-body">
                  <table style="width: 100%;border-spacing: 2em;border-collapse: separate;">
                    <tbody>
                    <tr>
                      <td width="20%" class="text-right"><img :src="$apiUrl + '/se/eye.png'" alt="graduation-cap"></td>
                      <td width="80%" class="text-left" style="padding-left: 30px">
                        <h5>The platform allows you to search, share and save the expertise you are looking for</h5>
                      </td>
                    </tr>
                    <tr style="margin-top: 15px">
                      <td width="20%" class="text-right"><img :src="$apiUrl + '/se/check-square.png'" alt="graduation-cap"></td>
                      <td width="80%" class="text-left" style="padding-left: 30px">
                        <h5>Try advanced features by creating a LEA account</h5>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                  <div style="margin-top: 15px">
                    <div class="col-xs-12 text-center">
                      <router-link type="button" :to="{name:'LeaPlans'}" class="btn btn-info"> Discover LEA subscription plans
                      </router-link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="hpanel plan-box hblue active">
          <div class="panel-body">
            <div class="row">
              <div class="col-xs-6">
              </div>
              <div class="col-xs-6 text-center">
                <div class="text-right">
                  <i style="margin-right: 20px"> version {{leaVersion}} </i>
                  <a href="https://www.idexlab.com/terms-of-use-idexlab-open-innovation-platform/" class="text-info " target="_blank">
                    [Legal Information]
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  table img {
    height: 40px;
  }
</style>
<script>
import VueLadda from 'vue-ladda'

export default {
  components: {VueLadda},
  name: 'LeaStaticBox',
  data () {
    return {
      videoUrl: 'https://schneider-electric.box.com/s/1qy85yoj5nv3ffaep2ginzzvg8hg4nyx',
      leaVersion: process.env.LEA_VERSION
    }
  }

}
</script>



// WEBPACK FOOTER //
// src/components/simpleInterface/LeaStaticBox.vue